import styled from 'styled-components';
import cssKit from '../../css';

const nissan = process.env.BRAND_NAME === 'nissan';

export const StyledErrorMessage = styled.div`
  margin-bottom: 1.5em;
  background-color: ${nissan ? '#568fe6' : '#efefef'};
  border: 1px solid #cccccc;
  padding: 1.5em;
  color: ${nissan ? '#fff' : '#000'};
`;

export const StyledErrorTitleText = styled.span`
  display: inline-block;
`;

export const StyledErrorHeading = styled.h3`
  color: ${nissan ? '#fff' : '#000'};
  display: flex;
  align-items: center;
  font-family: ${cssKit.fonts.regular};
`;

export const StyledErrorContent = styled.p`
  font-weight: normal;
  margin-bottom: 0;
  font-family: ${cssKit.fonts.regular};
`;

export const StyledErrorLink = styled.a`
  color: ${nissan ? '#fff' : '#000'};
  text-decoration: underline;
  font-family: ${cssKit.fonts.regular};
`;



/** WEBPACK FOOTER **
 ** ./src/components/ErrorMessage/styles.js
 **/